<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>安全股長名單</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li> <a href="/"> <i class="fa fa-home"></i></a></li>
          <li><span>安全股長名單</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                學年度：
                <select v-model="search.schYearTerm">
                  <option :value="null">請選擇</option>
                  <option v-for="item in schYearTermList" :key="item" :value="item.replace('/', '')">{{item}}</option>
                </select>　
                系所名稱：
                <select v-model="search.deptCode">
                  <option :value="null">請選擇</option>
                  <option v-for="(item, index) in deptList" :key="index" :value="item.code">{{item.value}}</option>
                </select>　
                學生姓名或學號： <input type="text" v-model="search.keyword" />
              </div>
              <div align="center" style="padding:7px;">
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="s_dir">
                <input ref="safetyFile" type="file" @change="safetyUpload()" style="display: none;" />
                <a href="#" @click.prevent="importSafety" class="btn-upload btn btn-primary">安全股長名單匯入</a>
              </div>
              <div style=" clear:both;">
                <a href="/bursary/files/安全股長名單.xlsx">安全股長名單(上傳範例)</a>
                <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center">刪除</th>
                      <th class="text-center">學年度</th>
                      <th class="text-center">系所名稱</th>
                      <th class="text-center">班級</th>
                      <th class="text-center">學號</th>
                      <th class="text-center">學生姓名</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="刪除" class="text-center">
                        <button type="button" @click.prevent="delData(item.id)" class="mb-xs mt-xs mr-xs btn-xs btn-primary"><i class="fa fa-minus-circle"></i></button>
                      </td>
                      <td data-title="學年度" class="text-center">{{item.schYearTerm}}</td>
                      <td data-title="系所名稱" class="text-center">{{item.deptName}}</td>
                      <td data-title="班級" class="text-center">{{item.dradeClass}}</td>
                      <td data-title="學號" class="text-center">{{item.studentId}}</td>
                      <td data-title="學生姓名" class="text-center">{{item.studentName}}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="row datatables-footer">
                  
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      search: {
        schYearTerm: null,
        deptCode: null,
        keyword: null
      },
      list: [],
      schYearTermList: [],
      deptList: []
    };
  },
  mounted() {
    let d = this.nowDate();
    let nowSchYear = d.getFullYear() - 1911;
    for (let i = nowSchYear; i >= 108; i--) {
      if (i == nowSchYear) {
        let month = d.getMonth() + 1;
        if (month < 8) continue;
        else this.schYearTermList.push(i.toString() + "/1");
      } else {
        this.schYearTermList.push(i.toString() + "/2");
        this.schYearTermList.push(i.toString() + "/1");
      }
    }
    this.$http.get("/api/shared/dept-list").then(a => {
      this.deptList = a.body;
    });
    this.load();
  },
  methods: {
    importSafety() {
      $(this.$refs.safetyFile).click();
    },
    safetyUpload() {
      let file = this.$refs.safetyFile.files[0];
      if (
        file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        alert("請上傳EXCEL檔(xlsx)");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      this.$http
        .post("/api/tenancySafety/import-safety", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(a => {
          if (a.body.status) {
            if (a.body.msg) {
              alert("匯入安全股長名單成功，但發生問題如下：\r\n" + a.body.msg);
            } else {
              alert("匯入安全股長名單成功");
            }
            this.load();
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table)
          .DataTable()
          .destroy();
      }
      this.$http
        .get("/api/tenancySafety", {
          params: {
            schYearTerm: this.search.schYearTerm,
            deptCode: this.search.deptCode,
            keyword: this.search.keyword
          }
        })
        .then(a => {
          this.list = a.body;
          this.$nextTick(b => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁"
              },
              columnDefs: [
                {
                  targets: 0,
                  orderable: false,
                }
              ],
              order: [1, "desc"],
              columns: [
                { width: "8%" },
                { width: "12%" },
                { width: "20%" },
                { width: "20%" },
                { width: "20%" },
                { width: "20%" }
              ]
            });
          });
        });
    },
    searchSubmit() {
      this.load();
    },
    searchClear() {
      this.search.schYearTerm = null;
      this.search.deptCode = null;
      this.search.keyword = null;
    },
    delData(id) {
      if (!confirm("請問是否確認要刪除此筆資料？")) return false;
      this.$http.delete("/api/tenancySafety/" + id).then(a => {
        if (a.body.status) {
          alert("刪除成功");
          this.load();
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    }
  }
};
</script>

<style>
</style>